import { useEffect } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

function Am5Chart(props) {
  let myData = props?.data || [];

  useEffect(() => {
    if (!myData?.length) return; // ✅ guard inside hook

    let root = am5.Root.new("chartdiv");

    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        paddingLeft: 0,
        wheelX: "panX",
        wheelY: "zoomX",
        layout: root.verticalLayout
      })
    );

    let legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.p50,
        x: am5.p50
      })
    );

    let data = myData;

    let xRenderer = am5xy.AxisRendererX.new(root, {
      cellStartLocation: 0.1,
      cellEndLocation: 0.9,
      minorGridEnabled: true
    });

    let xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "month",
        renderer: xRenderer,
        tooltip: am5.Tooltip.new(root, {})
      })
    );

    xAxis.data.setAll(data);

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
        integersOnly: true,
        maxPrecision: 0
      })
    );

    function makeSeries(name, fieldName) {
      let series = chart.series.push(
        am5xy.ColumnSeries.new(root, {
          name,
          xAxis,
          yAxis,
          valueYField: fieldName,
          categoryXField: "month"
        })
      );

      series.data.setAll(data);
      legend.data.push(series);
    }

    makeSeries("All", "All");
    makeSeries("Essential", "Essential");
    makeSeries("Functional", "Functional");
    makeSeries("Third Party", "Third Party");

    chart.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [myData]); // ✅ dependency added

  // ✅ condition AFTER hook
  if (!myData?.length) {
    return (
      <h5 className="cards-section text-center p-4">
        No Data Available.
      </h5>
    );
  }

  return (
    <div id="chartdiv" style={{ width: "100%", height: "500px" }} />
  );
}

export default Am5Chart;
